<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzMask]="true"
  [nzMaskClosable]="true"
  nzPlacement="right"
  [nzClosable]="false"
  [nzTitle]="'page.qualifications.drawer.title' | translate"
  (nzOnClose)="closeDrawer.emit()"
>
  <ng-container *nzDrawerContent>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'page.qualifications.partner' | translate }}
      </div>
      <wilson-shared-user-qualification-v2-partner-filter
        (modelChange)="onPartnerChange($event)"
      ></wilson-shared-user-qualification-v2-partner-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'general.users' | translate }}
      </div>
      <wilson-shared-user-filter
        (modelChange)="onUserIdsChange($event)"
      ></wilson-shared-user-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'account.status' | translate }}
      </div>
      <wilson-qualification-v2-status-filter
        (modelChange)="onStatusChange($event)"
      ></wilson-qualification-v2-status-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'page.qualifications.category' | translate }}
      </div>
      <wilson-qualification-v2-category-filter
        (modelChange)="onCategoryChange($event)"
      ></wilson-qualification-v2-category-filter>
    </div>
  </ng-container>
</nz-drawer>
